export default "__VITE_ASSET__AqQ5eaIr__"